export default "__VITE_ASSET__BqIwsKCG__"